import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import useLocale from "@/hooks/useLocale";
import teamVector from "@/assets/about/team-vector.png";
import Link from "next/link";

export default function Component({
  content: { title, content, link, people },
  path,
}) {
  const locale = useLocale();

  return (
    <div className="relative min-h-[450px] md:min-h-[752px] h-full flex justify-center items-center">
      <img
        src={teamVector ?? ""}
        alt="team vector"
        className="absolute w-full top-52"
      />
      <div className="relative flex flex-col items-center bg-gradientOpacity w-[88%] gap-5">
        {people && (
          <p className="text-pink text-lg/[27px] font-semibold">
            <CustomSourceFlowText
              title="CSR"
              path={`dynamic1.${path}.csr`}
              locale={locale}
            />
          </p>
        )}
        <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] text-purple max-w-[590px] w-full text-center">
          <CustomSourceFlowText
            title={title}
            path={`dynamic1.${path}.title`} x
            locale={locale}
          />
        </h2>
        <h6 className="text-sm sm:text-[16px] xl:text-[16px]/[16px] text-purple max-w-[590px] w-full text-center">
          For information on how we handle your personal data, please refer to our Privacy Policy, which can be found <Link href={`/${locale !== "en" ? locale + "/" : ""}legal/privacy-policy`}>
          <span className="font-bold underline privacy-policy">here</span>
          </Link>.
        </h6>
        <p className="max-w-[589px] w-full text-purple text-center text-xl sm:text-[25px]/[37px] sm:mb-5">
          <CustomSourceFlowText
            title={content}
            path={`dynamic1.${path}.info`}
            locale={locale}
          />
        </p>
        <a
          href={link.href}
          className="text-[#1B0D34] m-auto text-xl self-end sm:text-xl text-center pt-4 group text-decoration-none group-hover:text-purple"
        >
          <div className="flex justify-center">
            <p className="">
              <CustomSourceFlowText
                title={link.txt}
                path={`dynamic1.${path}.linktxt`}
                locale={locale}
              />
              <span className="w-0 bg-purple h-[1px] mt-[-5px] transition-all block group-hover:w-full" />
            </p>
          </div>
        </a>
      </div>
    </div>
  );
}
